/**
 * Base URL of the sponsorship app (brain-event-sponsorship).
 * Set REACT_APP_SPONSOR_APP_URL in .env to override.
 * All "Devino Sponsor" / "Aplică pentru Sponsorizare" links go to this main page (not directly to the form).
 */
const SPONSOR_APP_URL = process.env.REACT_APP_SPONSOR_APP_URL || 'https://sponsori.brain-event.com';
export const SPONSOR_FORM_URL = SPONSOR_APP_URL.replace(/\/$/, '');
